import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Checkbox,
  Grid,
  InputLabel,
  DialogContent,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import DialogActions from "@material-ui/core/DialogActions";
import Loading from "../shared/Loading";
import { useSnackbar } from "notistack";
import { useSelector } from "../../store";
import { IRootState } from "../../interfaces/store";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";

interface IBusinessUnitsModalProps {
  itemData: any;
  open: boolean;
  onClose: Function;
  title: string;
  onSubmit: Function;
  isEditMode: boolean;
  isCompany: boolean;
}

const BusinessUnitsModal: React.FC<IBusinessUnitsModalProps> = (props) => {
  const [errors, setErrors] = useState({} as any);
  const { enqueueSnackbar } = useSnackbar();
  const [processing, setProcessing] = useState(false);

  const [companyFk, setCompanyFk] = useState(props.itemData.companyFk);
  const [pk, setPk] = useState(props.itemData.pk);
  const [businessUnitName, setBusinessUnitName] = useState(
    props.itemData.businessUnitName
  );

  const mines = useSelector((state: IRootState) => state.main.mines);
  const [selectedMines, setSelectedMines] = useState([] as any);
  const [mineList, setMineList] = useState([] as any);

  useEffect(() => {
    if (props.itemData.selectedMines) {
      const mineList = Object.values(mines).filter(
        (item) => item.companyFk === Number(props.itemData.companyFk)
      );
      setMineList(mineList);

      const mineSelection: any[] = mineList.filter((item: any) =>
        props.itemData.selectedMines.includes(item.pk)
      );
      setSelectedMines(mineSelection);
    }
    setCompanyFk(props.itemData.companyFk);
    setBusinessUnitName(props.itemData.businessUnitName);
    setPk(props.itemData.pk);
  }, [props.itemData]);

  const submitForm = () => {
    setProcessing(true);
    if (!formIsValid()) return;

    const body = {
      pk,
      companyFk,
      businessUnitName,
      selectedMines: selectedMines.map(function (item: any) {
        return item.pk;
      }),
    };

    props.onSubmit(
      body,
      () => {
        setProcessing(false);
        enqueueSnackbar("Changes were saved successfully..", {
          variant: "success",
        });
      },
      (message?: string) => {
        setProcessing(false);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    );
  };

  const isMineSelected = (item: any): boolean => {
    var data = selectedMines.filter((el: any) => el.pk === item.pk);
    return data.length > 0 ? true : false;
  };

  const onChangeSelectedMines = (item: any) => () => {
    const newMineList = [...selectedMines];
    const found = newMineList.filter((element) => element.pk === item.pk);
    if (found.length > 0)
      setSelectedMines(newMineList.filter((element) => element.pk !== item.pk));
    else {
      newMineList.push(item);
      setSelectedMines(newMineList);
    }
  };

  function formIsValid() {
    const _errors: any = {};

    if (!businessUnitName)
      _errors.businessUnitName = "Business unit Name is required";
    if (!selectedMines.length)
      _errors.selectedMines = "You must select one or more mines";

    setErrors(_errors);

    return Object.keys(_errors).length === 0;
  }

  return (
    <>
      <Loading loading={processing} />
      <Dialog
        onClose={() => props.onClose()}
        aria-labelledby="customized-dialog-title"
        maxWidth="lg"
        open={props.open}
      >
        <MuiDialogTitle>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 3 }}>
              <Typography variant="h6">
                {(props.isEditMode ? "Edit " : "Add ") + props.title}
              </Typography>
            </div>
            <div style={{ flex: 1, textAlign: "right" }}>
              <IconButton aria-label="close" onClick={() => props.onClose()}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </MuiDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <div className={errors.businessUnitName ? "error " : ""}>
                <InputLabel
                  htmlFor="businessUnitName"
                  style={{ display: "inline-block" }}
                >
                  Business Unit Name:
                </InputLabel>
                <em>{errors.businessUnitName}</em>
                <TextField
                  fullWidth
                  id="businessUnitName"
                  size="small"
                  variant="outlined"
                  onChange={(event) => {
                    setBusinessUnitName(event?.target.value);
                  }}
                  value={businessUnitName}
                />
              </div>
            </Grid>
            <Grid item xs={12} lg={12}>
              <InputLabel
                htmlFor="businessUnitName"
                style={{ display: "inline-block" }}
              >
                Business Unit Mines:
              </InputLabel>
              <em>{errors.selectedMines}</em>
              <List dense={true} style={{ maxHeight: 300 }}>
                {mineList.map((value: any) => {
                  const labelId = `checkbox-list-label-${value.pk}`;

                  return (
                    <ListItem
                      key={value.pk}
                      role={undefined}
                      dense
                      button
                      onClick={onChangeSelectedMines(value)}
                    >
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ "aria-labelledby": labelId }}
                          checked={isMineSelected(value)}
                        />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={value.mineName} />
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            autoFocus
            onClick={() => submitForm()}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BusinessUnitsModal;
